import React, { useEffect } from 'react';
import styles from '../Onboarding/Onboarding.module.css';
import loginStyles from '../Login/LoginPage.module.css';
import Spinner from '../Spinner/Spinner';
//import { CreateCheckoutSessionService } from '../../Services/StripeService';

const Premium = () => {
  useEffect(() => {
    window.location.replace("/Billing/Checkout?plan=pro");
  }, []);
 
  return (
    <div>
        <div className={`${styles.row}`}>
            <div className={`${loginStyles.rightbackground} col-6 `}>
            <Spinner />
            </div>
        </div>
    </div>
  );
};
export default Premium;